import { Injectable } from '@angular/core';

@Injectable()
export class LMPagePanelHelperService {
  public getPagePaneClasses(panel: LMPagePanelSpec, pane: LMMultiPagePaneSpec): string {
    const type = panel.panelLayoutType;
    const paneNum = parseInt(pane.paneName.substring(4), 10);

    switch (type) {
      case 1:
        if (paneNum === 1) {
          return 'pane left no-scroll';
        }
        if (paneNum === 3) {
          return 'pane right no-scroll';
        }
        break;
      case 2:
        if (paneNum === 1) {
          return 'pane top no-scroll';
        }
        if (paneNum === 2) {
          return 'pane bottom no-scroll';
        }
        break;
      case 3:
        if (paneNum === 1) {
          return 'pane top-left no-scroll';
        }
        if (paneNum === 2) {
          return 'pane bottom-left no-scroll';
        }
        if (paneNum === 3) {
          return 'pane right no-scroll';
        }
        break;
      case 4:
        if (paneNum === 2) {
          return 'pane left no-scroll';
        }
        if (paneNum === 3) {
          return 'pane top-right no-scroll';
        }
        if (paneNum === 4) {
          return 'pane bottom-right no-scroll';
        }
        break;
      case 5:
        if (paneNum === 1) {
          return 'pane top no-scroll';
        }
        if (paneNum === 2) {
          return 'pane bottom-left no-scroll';
        }
        if (paneNum === 4) {
          return 'pane bottom-right no-scroll';
        }
        break;
      case 6:
        if (paneNum === 1) {
          return 'pane top-left no-scroll';
        }
        if (paneNum === 3) {
          return 'pane top-right no-scroll';
        }
        if (paneNum === 4) {
          return 'pane bottom no-scroll';
        }
        break;
      case 7:
        if (paneNum === 1) {
          return 'pane top-left no-scroll';
        }
        if (paneNum === 2) {
          return 'pane bottom-left no-scroll';
        }
        if (paneNum === 3) {
          return 'pane top-right no-scroll';
        }
        if (paneNum === 4) {
          return 'pane bottom-right no-scroll';
        }
        break;
    }

    return 'pane single no-scroll';
  }

  public reorderDependentPanes(pagePanelSpec: LMPagePanelSpec): Array<LMMultiPagePaneSpec> {
    const orderedPanes: Array<LMMultiPagePaneSpec> = new Array(0);
    const processedPaneList: Array<string> = new Array(0);

    for (const pane of pagePanelSpec.panes) {
      // continue if already processed
      if (processedPaneList.indexOf(pane.paneId) > -1) {
        continue;
      }

      // skip pane if it is a menu panel layout. not supported yet.
      if (pane.paneType === 'MenuPanel') {
        continue;
      }

      // not a dependent pane
      if (!pane.isRelativePanel) {
        // added to order panes list and mark as processed.
        orderedPanes.push(pane);
        processedPaneList.push(pane.paneId);

        // if there are dependent panes process them before
        // moving on to the next pane ins the panel.panes array.
        if (pane.hasDependentPanels) {
          this.processDependentPanes(pagePanelSpec, pane, orderedPanes, processedPaneList);
        }
      }
    }

    return orderedPanes;
  }

  private processDependentPanes(
    pagePanelSpec: LMPagePanelSpec,
    multiPanePanelSpec: LMMultiPagePaneSpec,
    orderedPanes: Array<LMMultiPagePaneSpec>,
    processedPaneList: Array<string>): void {
    const depPanes: Array<LMMultiPagePaneSpec> = this.getDependentPagePanes(pagePanelSpec, multiPanePanelSpec.paneId);

    for (const depMultiPaneSpec of depPanes) {
      orderedPanes.push(depMultiPaneSpec);
      processedPaneList.push(depMultiPaneSpec.paneId);

      if (depMultiPaneSpec.hasDependentPanels) {
        this.processDependentPanes(pagePanelSpec, depMultiPaneSpec, orderedPanes, processedPaneList);
      }
    }
  }

  private getDependentPagePanes(pagePanelSpec: LMPagePanelSpec, paneId: string): Array<LMMultiPagePaneSpec> {
    const depPaneArray: Array<LMMultiPagePaneSpec> = new Array(0);

    const multiPane: LMMultiPagePaneSpec = this.getPaneById(pagePanelSpec, paneId);
    for (const depPaneId of multiPane.pane.depPanes) {
      depPaneArray.push(this.getPaneById(pagePanelSpec, depPaneId));
    }

    return depPaneArray;
  }

  private getPaneById(pagePanelSpec: LMPagePanelSpec, paneId: string): LMMultiPagePaneSpec {
    for (const pane of pagePanelSpec.panes) {
      if (pane.paneId === paneId) {
        return pane;
      }
    }

    return null;
  }
}
